/**
 * Just a wrapped version of confirmation toast using promises for a nicer calling experience.
 * Note that it does not distinguish between cancelled and escaped.
 */
import * as _ from 'lodash';
import { DEFAULT_CANCEL_TEXT, DEFAULT_CONFIRM_TEXT } from './confirmation_modal.service';
import { PromisedNWayConfirmationModal } from 'app/shared/modal/n_way_confirmation/promised_n_way_confirmation_modal';
import { getNWayConfirmationMode } from 'app/shared/modal/n_way_confirmation/n_way_confirmation_modal.service';

export class PromisedConfirmationModalFactory {
    public create(
        message: string,
        confirmText?: string,
        cancelText?: string,
        displayCancelButton?: boolean,
        alternativeStyle?: boolean,
        escapeCallback?: boolean,
    ): PromisedConfirmationModal {
        return new PromisedConfirmationModal(
            message,
            confirmText,
            cancelText,
            displayCancelButton,
            alternativeStyle,
            escapeCallback,
        );
    }
}

export class PromisedConfirmationModal extends PromisedNWayConfirmationModal {
    static get CANCELLED() {
        return 'cancelled';
    }

    static get CONFIRMED() {
        return 'confirmed';
    }

    constructor(
        message: string,
        confirmText = DEFAULT_CONFIRM_TEXT,
        cancelText = DEFAULT_CANCEL_TEXT,
        displayCancelButton = true,
        alternativeStyle = false,
        escapeCallback = true,
    ) {
        const modes = [
            getNWayConfirmationMode(
                DEFAULT_CONFIRM_TEXT,
                PromisedConfirmationModal.CONFIRMED,
                confirmText,
                false,
                false,
            ),
            getNWayConfirmationMode(
                DEFAULT_CANCEL_TEXT,
                PromisedConfirmationModal.CANCELLED,
                cancelText,
                true,
                escapeCallback,
                displayCancelButton,
            ),
        ];

        super(message, modes, alternativeStyle);
    }
}

export function deleteConfirmationModal(
    name,
    additionalText = '',
    confirmText = 'Delete it',
    cancelText = 'Cancel',
) {
    const space = _.isEmpty(additionalText) ? '' : ' ';
    const message = `Are you sure you want to delete ${name}?${space}${additionalText}`;
    return new PromisedConfirmationModal(message, confirmText, cancelText, true);
}

export function unsavedChangesConfirmationModal(name: string, tabs = []) {
    let message;
    if (tabs.length) {
        const lastTab = tabs.pop();
        const tabText =
            tabs.length > 0 ? tabs.join(', ') + ' and ' + lastTab + ' tabs' : lastTab + ' tab';
        message = `You have unsaved changes in the ${tabText} on this ${name}. Do you wish to discard these changes?`;
    } else {
        message = `You have unsaved changes on this ${name}. Do you wish to discard these changes?`;
    }

    const confirmText = `Discard these changes`,
        cancelText = `Cancel`;
    return new PromisedConfirmationModal(message, confirmText, cancelText, true);
}
